<template>
	<div>
		<div class="treeMap_echarts" :id="echartsId"></div>
	</div>
</template>
<script>
export default {
	name: '',
	components: {},
	mixins: [],
	props: ['echartsData', 'echartsId'],
	data() {
		return {};
	},
	computed: {},
	watch: {
		echartsData: {
			handler(val) {
				this.getEcharts(val);
			},
			// immediate: true,不能加深度监听  数据为空的时候也加载了
		},
	},
	mounted() {},
	methods: {
		getEcharts(echartsData) {
			var chartDom = document.getElementById(this.echartsId);
			var myChart = this.$echarts.init(chartDom);
			let legenddata = echartsData.legend;
			let xAxisdata = echartsData.xAxis;
			let unit = echartsData.unit;
			let _this = this;
			let option = {
				color: [
					'#beceb4',
					'#91ac83',
					'#789a61',
					'#688c30',
					'#4f7a37',
					'#418c65',
					'#2f7842',
					'#238c6b',
				],
				tooltip: {
					trigger: 'axis',
					confie: true,
					formatter(item) {
						return _this.getTootip(item, unit);
					},
				},
				legend: {
					itemGap: 5,
					itemWidth: 20,
					itemHeight: 10,
					textStyle: {
						color: '#595959',
					},
					type: 'scroll',
					bottom: 0,
					data: legenddata,
				},
				grid: {
					left: '4%',
					right: '4%',
					bottom: '8%',
					top: '12%',
					containLabel: true,
				},
				xAxis: {
					type: 'category',
					axisLine: {
						lineStyle: {
							color: '#f2f2f2',
						},
					},
					axisTick: {
						show: false,
					},

					axisLabel: {
						show: true, //坐标轴刻度标签的相关设置。
						interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
						rotate: 40,
						textStyle: {
							color: '#595959',
							fontStyle: 'normal',
							fontSize: 12,
						},
					},
					data: xAxisdata,
				},
				yAxis: [
					{
						// name: '单位：' + unit,
						// nameLocation: 'end',
						// nameTextStyle: {
						// 	color: 'rgba(51, 51, 51, 1)',
						// 	fontSize: 12,
						// 	align: 'center',
						// },
						type: 'value',

						axisTick: {
							show: false,
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#273860',
							},
						},
						splitLine: {
							lineStyle: {
								color: '#f2f2f2',
							},
						},
					},
				],
				series: [],
			};
			for (var index = 0; index < legenddata.length; index++) {
				option.series.push({
					name: legenddata[index],
					type: 'bar',
					stack: '总量',
					label: {
						show: false,
						position: 'insideTop',
					},
					// xAxisIndex: 0,
					// barGap: '-100%',
					barWidth: '30%',
					data: echartsData['bar' + (index + 1)],
				});

				// option.legend.data.push(JBXXQYNL[index].name);
			}
			myChart.clear();
			myChart.setOption(option);
			myChart.on('click', function(param) {
				//console.log(param);
			});
		},
		//设置鼠标悬浮事件
		getTootip(item, unitlist) {
			let allStr = item[0].name + '<br/>';
			for (let index = 0; index < item.length; index++) {
				const element = item[index];
				allStr +=
					//图例
					element.marker +
					//图例名称
					element.seriesName +
					'：' +
					//值
					(element.value ? element.value : '-') +
					//单位
					(element.value
						? unitlist[
								unitlist.findIndex(
									(item) => item.name == element.seriesName
								)
						  ].unit
						: '') +
					// 换行
					(item.length != index ? '<br/>' : '');
			}
			return allStr;
		},
	},
};
</script>
<style lang="less" scoped>
.treeMap_echarts {
	width: 401px;
	height: 205px;
}
</style>



// WEBPACK FOOTER //
// src/view/actionPlan/components/stackedBar2/index.vue